<div class="@container">
  <div class="ticker flex-col items-start @4xs:flex-row @4xs:items-center">
    <div class="icon-wrapper aspect-square" [class]="getIconClass()">
      <i [class]="'fa fa-' + icon"></i>
    </div>
    <div class="middle text-center @4xs:text-left">
      <div class="total">
        {{ total }}
      </div>
      <div class="eliso-card-title">
        {{ titleText }}
      </div>
      <div class="text-xs">
        {{ descriptionText }}
      </div>
    </div>
    @if (percentage !== 0) {
      <div
        class="percentage"
        [class]="percentage > 0 ? 'positive' : 'negative'"
      >
        <div
          [class]="'fa fa-' + (percentage > 0 ? 'chevron-up' : 'chevron-down')"
        ></div>
        <i class="value"></i>
        <span>{{ abs(percentage) }}%</span>
      </div>
    }
  </div>
</div>
